/**
 * router gaurd.
 */
import store from '../store'
import CONFIG from '@/config'

export const authorizeToken = (to, from, next) => {

  // sessionLoad();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth || !store.state.auth.user || !store.state.auth.token) {
      next({ path: '/login' })
    }
    else {
      next()
    }
  }
  else {
    next();
  }
}



// WEBPACK FOOTER //
// ./src/router/guards.js